import React, { Component } from 'react';
import { connect } from 'react-redux';
import { QRCodeCanvas } from "qrcode.react";
import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
import BusinessUserSideBar from "../components/container/SideBar";
import ClientSideBar from "../components/container/layout/client/SideBar";
import FooterSection from "../components/UI/FooterSection";
import SpanField from "../components/UI/SpanField";
import axios from "axios";
import { CONFIG } from "../config/data";
import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}

class PatientBookingLink extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
            formSuccess: {
                message: "",
                status: "",
            },
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
    };

    handleClose() {
        this.setState({ showModal: false })
    }

    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();
    };

    _onAction(e) {
        this.setState({ isTimedOut: false })
    }

    _onActive(e) {
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        if (isTimedOut === false) {
            this.setState({ showModal: true })
            this.idleTimer.reset();
            this.setState({ isTimedOut: true })
        }
        if (isTimedOut === true) {
            localStorage.removeItem("token");
            this.props.logout();
        }
    }

    // --- Copy Link ---
    copyHospitalLink = () => {
        const business_id = this.props.userdata.id;
        const shareUrl = `${window.location.origin}/login?redirect=/search?business_id=${business_id}`;
        navigator.clipboard.writeText(shareUrl);
        this.setState({
            formSuccess: {
                message: "Patient booking link copied! Share it via WhatsApp or SMS.",
                status: "1",
            },
        });
        this.clearMessage();
    };

    // --- Download QR ---
    downloadQRCode = () => {
        const canvas = document.querySelector("canvas");
        if (canvas) {
            const pngUrl = canvas
                .toDataURL("image/png")
                .replace("image/png", "image/octet-stream");
            let downloadLink = document.createElement("a");
            downloadLink.href = pngUrl;
            downloadLink.download = "hospital-booking-qrcode.png";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            this.setState({
                formSuccess: {
                    message: "QR Code downloaded successfully!",
                    status: "1",
                },
            });
            this.clearMessage();
        }
    };

    clearMessage = () => {
        setTimeout(() => {
            this.setState({
                formSuccess: { message: "", status: "" },
            });
        }, 3000);
    };

    componentDidMount = () => {
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;

        axios
            .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
            .then((res) => {
                let data = res.data;
                if (data.status === "1")
                    this.setState({
                        hospitaltimeout: data.data.timeout
                    });
            })
            .catch((e) => { });
    }

    render() {
        const { hospitaltimeout, formSuccess } = this.state;
        const business_id = this.props.userdata.id;
        const shareUrl = `${window.location.origin}/login?redirect=/search?business_id=${business_id}`;

        return (
            <div className="main-content bacfot">
                <div className="mainpage">
                    <section className="my-head">
                        <div className="container-fluid">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessHeader user_id={this.props.userdata.id} />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserHeader user_id={this.props.userdata.id} />
                            ) : (
                                <Header user_id={this.props.userdata.id} />
                            )}
                        </div>
                    </section>
                    <div className="main-box">
                        <div className="sidemenu">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessUserSideBar />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserSideBar />
                            ) : (
                                <ClientSideBar />
                            )}
                        </div>

                        <section className="main-body hospital-profilegap">
                            <IdleTimeOutModal
                                showModal={this.state.showModal}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            />
                            <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={hospitaltimeout}
                            />

                            <div className="container-fluid checkout-tabs">
                                <div className="row mb-3">
                                    <div className="col-sm-12">
                                        <h4 className="font-weight-bold">
                                            Patient Booking Link
                                        </h4>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6 offset-sm-3">
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="card-title">
                                                    <i className="fa fa-share-alt"></i> Share with Patients
                                                </div>
                                            </div>
                                            <div className="card-body pd-10">

                                                <p className="font-family text-center"
                                                    style={{ fontSize: '13px', color: '#666' }}>
                                                    Share this QR code or link with your patients.
                                                    When they scan or click it, they will login and
                                                    directly reach your hospital booking page.
                                                </p>

                                                <SpanField
                                                    classname={
                                                        "0" === formSuccess.status
                                                            ? "text-danger user-notification"
                                                            : "text-success user-notification"
                                                    }
                                                    title={formSuccess.message}
                                                />

                                                {/* QR Code */}
                                                <div className="text-center mt-3 mb-3">
                                                    <p className="font-family" style={{
                                                        fontSize: '13px',
                                                        fontWeight: 'bold',
                                                        marginBottom: '10px'
                                                    }}>
                                                        <i className="fa fa-qrcode"></i> Scan QR Code to Book
                                                    </p>
                                                    <div style={{
                                                        display: 'inline-block',
                                                        padding: '10px',
                                                        backgroundColor: '#fff',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '8px'
                                                    }}>
                                                        <QRCodeCanvas
                                                            value={shareUrl}
                                                            size={200}
                                                            bgColor="#ffffff"
                                                            fgColor="#000000"
                                                            level="H"
                                                            includeMargin={true}
                                                        />
                                                    </div>
                                                    <p className="font-family mt-2"
                                                        style={{ fontSize: '11px', color: '#999' }}>
                                                        Patient scans this with phone camera
                                                    </p>
                                                </div>

                                                {/* Hidden URL */}
                                                <input
                                                    type="text"
                                                    readOnly
                                                    value={shareUrl}
                                                    style={{
                                                        position: 'absolute',
                                                        opacity: 0,
                                                        pointerEvents: 'none',
                                                        width: 0,
                                                        height: 0
                                                    }}
                                                    id="hospitalShareUrl"
                                                />

                                                {/* Buttons */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    flexWrap: 'nowrap'
                                                }}>
                                                    {/* Copy Button */}
                                                    <button
                                                        className="signupbtn abtn"
                                                        onClick={this.copyHospitalLink}
                                                        style={{
                                                            marginTop: 0,
                                                            padding: '6px 14px',
                                                            fontSize: '12px',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        <i className="fa fa-copy"></i> Copy Link
                                                    </button>

                                                    {/* Download QR Button */}
                                                    <button
                                                        className="signupbtn abtn"
                                                        onClick={this.downloadQRCode}
                                                        style={{
                                                            marginTop: 0,
                                                            padding: '6px 14px',
                                                            fontSize: '12px',
                                                            whiteSpace: 'nowrap',
                                                            minWidth: '120px'
                                                        }}
                                                    >
                                                        <i className="fa fa-download"></i> Download QR
                                                    </button>

                                                    {/* WhatsApp Button */}
                                                    <a
                                                        href={`https://wa.me/?text=Book your appointment at our hospital: ${shareUrl}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="signupbtn abtn"
                                                        style={{
                                                            marginTop: 0,
                                                            padding: '6px 14px',
                                                            fontSize: '12px',
                                                            backgroundColor: '#25D366',
                                                            display: 'inline-block',
                                                            textDecoration: 'none',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        <i className="fa fa-whatsapp"></i> WhatsApp
                                                    </a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <FooterSection />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientBookingLink);